export const COMPANY_LIST_CLEAR_STORE = "COMPANY_LIST_CLEAR_STORE";

export const COMPANY_LIST_SUMMURY_LOAD_START = "COMPANY_LIST_SUMMURY_LOAD_START";
export const COMPANY_LIST_SUMMURY_LOAD_SUCCESS = "COMPANY_LIST_SUMMURY_LOAD_SUCCESS";
export const COMPANY_LIST_SUMMURY_LOAD_FAIL = "COMPANY_LIST_SUMMURY_LOAD_FAIL";

export const COMPANY_LIST_LOAD_START = "COMPANY_LIST_LOAD_START";
export const COMPANY_LIST_LOAD_SUCCESS = "COMPANY_LIST_LOAD_SUCCESS";
export const COMPANY_LIST_LOAD_FAIL = "COMPANY_LIST_LOAD_FAIL";

export const COMPANY_LIST_REMOVE_START = "COMPANY_LIST_REMOVE_START";
export const COMPANY_LIST_REMOVE_SUCCESS = "COMPANY_LIST_REMOVE_SUCCESS";
export const COMPANY_LIST_REMOVE_FAIL = "COMPANY_LIST_REMOVE_FAIL";
